import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { renderFieldSelect } from '../../util/inputs';
import salvarCidadesConexao from '../../actions/rota/salvarCidadesConexao';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalAdicionarCidades extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);

    this.state = {
      cidadesSelecionda: []
    }
  }

  fecharModal () {
    this.props.limparCidadesConexao();
    $('#modalAdicionarCidades')
      .modal('hide');
    $('#modalAdicionarCidades')
      .hide();
    $('.modal-backdrop')
      .hide();      
  }

  exibeCidades() {
    return (<>
      <div>
            <table className="table table-sm table-bordered">
                <thead>
                    <tr>                            
                        <th scope="col">Descrição</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.cidadesSelecionda && this.props.cidadesSelecionda.length === 0 ?
                        <tr className="alert alert-warning text-center mt-4" role="alert">
                            <td colSpan='3'>
                                Nenhum item adicionado.
                            </td>
                        </tr>
                        : this.props.cidadesSelecionda && this.props.cidadesSelecionda.map(it => (
                            <tr key={it.id}>                                    
                                <td>{it.descricao}</td>                                    
                                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                    <div onClick={() => this.remover(it.cidadeId)}>
                                        Remover
                                    </div>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>     
    </>)
  }

  remover(cidadeId) {    
    const cidadesSelecionda = Object.assign([], this.props.cidadesSelecionda);    
    this.props.preencherCidades(cidadesSelecionda.filter(it => !(it.cidadeId === cidadeId)));
  }

  adicionar(e) {
    e.preventDefault();
    if (this.props.cidadesSelecionda.filter(it => it.cidadeId === e.value).length === 0) {
        const cidade = this.props.cidadesTrechos.find(it => it.id === e.value)
        if (cidade) {
            const cidades = Object.assign([], this.props.cidadesSelecionda);
            cidades.push({id: null, cidadeId: cidade.id, descricao: `${cidade.nome}-${cidade.uf}`});
            this.props.preencherCidades(cidades);
        }            
    }
}

  submit() {    
    this.props.salvarCidadesConexao(this.props.conexaoSelecionada.id, { cidadesConexao: this.props.cidadesSelecionda })
      .then(({payload: { status }}) => {
        if (status == 200) {
          if (this.props.cidadesSelecionda.length === 0) {
            showSuccessMsg('As cidades foram removido com sucesso!');
          } else {
            showSuccessMsg('As cidades foram salva com sucesso!');
          }
          this.props.buscarRotas();
          this.fecharModal();
        }
      })
  }

  render () {
      const {
        handleSubmit
      } = this.props;      
      return (
        <div className="modal fade show" id='modalAdicionarCidades' role='dialog'
              aria-labelledby='modalAdicionarCidades' aria-hidden='true' data-backdrop='static'>
          <div className={'modal-dialog modal-dialog-centered modal-lg'}>
            <div className="modal-content">
              <div className="modal-header">
                <h5>Adicionar Cidades Origem - {this.props.conexaoSelecionada ? `Conexão: ${this.props.conexaoSelecionada.prefixo} ${this.props.conexaoSelecionada.cidadeOrigem.nomeComUf}`: null}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                        onClick={() => this.props.limparCidadesConexao()}>
                  <i className="material-icons">
                    &#xe5cd;
                  </i>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit(this.submit)}>                  
                  <div className="form-row mb-2">
                    <div className="col-12 col-sm-9 col-md-9">
                      <Field name='cidades'
                          options={this.props.cidadesTrechos.filter(c => !this.props.cidadesSelecionda.map(it => it.cidadeId).includes(c.id))
                            .map(it => {
                              return {                                                            
                                  descricao: `${it.nome}-${it.uf}`,
                                  nome: it.id
                              }
                          })}
                          component={renderFieldSelect}
                          isClearable
                          label='Cidades'
                          placeholder='Selecione...'
                          onChange={(e) => this.adicionar(e)}
                      />                      
                    </div>
                  </div>
                  <div className='form-row'>
                      <div className='col-sm-10 col-md-10'>
                      {this.exibeCidades()}
                      </div>
                  </div>
                  <div className="modal-footer mt-4">
                    <button type="submit"
                            className="btn btn-laranja">Salvar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      );
    }
}


export function mapStateToProps(state) {
    return {                
        cidadesTrechos: state.cidadesTrechos
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
      salvarCidadesConexao    
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAdcionarCidades'    
})(ModalAdicionarCidades));